import {
	Injectable
} from '@angular/core';

import {
	forkJoin,
	Observable
} from 'rxjs';

import {
	map
} from 'rxjs/operators';

import {
	AssetsService,
	CardModel,
	CookiesPopinContent
} from 'dd1pnds-ngx-libs';

import {
	Dd1pndsNgGetDataService
} from 'dd1pnds-ngx-services';

import {
	FooterContentModel
} from 'dd1pnds-ngx-libs/lib/ui/dd1pnds-ng-footer/dd1pnds-ng-footer.model';

import {
	HeaderContentModel
} from 'dd1pnds-ngx-libs/lib/ui/dd1pnds-ng-header/dd1pnds-ng-header.model';

import {
	FaqSectionModel
} from '../../models/landing-page/faq/faq.model';

import {
	BandeauModel,
	FormulaireModel
} from '../../models/landing-page/landing-page.model';


@Injectable({
	providedIn: 'root'
})
export class AvvcCmsService {
	/**
	 * Represents the header content.
	 */
	headerContent: HeaderContentModel;

	/**
	 * Represents the footer content.
	 */
	footerContent: FooterContentModel;

	/**
	 * Represents the popin cookies content.
	 */
	popinCookiesContent: CookiesPopinContent;

	// The content for the "partenaires" section of the page
	cartesPartenairesTitre: string;
	/**
	 * Represents the content of the cards in the "partenaires" section.
	 */
	cartesPartenaires: CardModel[];

	/**
	 * Represents the content of the FAQ.
	 */
	faqContent: Record<string, FaqSectionModel>;

	/**
	 * Represents the content of the page between the page title and the FAQ
	 */
	bandeauContent: BandeauModel;

	/**
	 * Represents the content of the page between the page title and the FAQ
	 */
	formulaireEligibiliteContent: FormulaireModel;

	constructor(
		private getDataService: Dd1pndsNgGetDataService,
		private assetsService: AssetsService
	) { }

	/**
	 * Retrieves the CMS data for the AVVC page : the introduction, the FAQ, the eligibility form
	 * and the cards redirecting to external partners or internal services.
	 * @returns  The CMS data as an observable.
	 */
	public loadCmsAvvcData(): Observable<void> {
		return forkJoin([
			this.getDataService.getJSON('avvc', 'landing', 'bandeau.json'),
			this.getDataService.getJSON('avvc', 'landing', 'faq.json'),
			this.getDataService.getJSON('avvc', 'landing', 'questionnaire.json'),
			this.getDataService.getJSON('avvc', 'landing', 'cartes-partenaires.json')
		]).pipe(
			map(([bandeau, faq, formulaire, cartesPartenaires]) => {
				this.bandeauContent = bandeau;
				this.faqContent = faq.questions;
				this.formulaireEligibiliteContent = formulaire;
				this.cartesPartenairesTitre = cartesPartenaires.titre;
				this.cartesPartenaires = cartesPartenaires.cardsContent;
			})
		);
	}

	/**
	 * Retrieves the CMS data for the landing-page.
	 */
	public loadAppCmsData(): Observable<void> {
		return forkJoin([
			this.getDataService.getJSON('shared', 'content', 'header-content.json'),
			this.getDataService.getJSON('shared', 'content', 'footer-content.json'),
			this.getDataService.getJSON('shared', 'popins', 'popin-cookies.json')
		]).pipe(
			map(([header, footer, popinCookies]) => {
				this.headerContent = header;
				this.footerContent = footer;
				this.popinCookiesContent = popinCookies;
			})
		);
	}

	public getBandeauContent(): BandeauModel {
		return this.bandeauContent;
	}

	public getFaqContent(): Record<string, FaqSectionModel> {
		return this.faqContent;
	}

	public getFormulaireEligibiliteContent(): FormulaireModel {
		return this.formulaireEligibiliteContent;
	}

	public getCartesPartenairesTitre(): string {
		return this.cartesPartenairesTitre;
	}

	public getCartesPartenaires(): CardModel[] {
		return this.cartesPartenaires;
	}

	/**
	 * Allows to retrieve the CMS data for the header.
	 * @returns The data for the header
	 */
	public getHeaderContent(): HeaderContentModel {
		return this.headerContent;
	}

	/**
	 * Allows to retrieve the CMS data for the footer.
	 * @returns The data for the footer
	 */
	public getFooterContent(): FooterContentModel {
		return this.footerContent;
	}

	/**
	 * Allows to retrieve the CMS data for the popin cookies.
	 * @returns the data for the footer
	 */
	public getPopinCookiesContent(): CookiesPopinContent {
		return this.popinCookiesContent;
	}
}
